import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
}

const MainSvg: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <mask id='path-1-inside-1_2310_38841' fill='currentColor'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M2.67087 4.59959C1.93261 5.16748 1.5 6.04606 1.5 6.97746V11.5003C1.5 13.1571 2.84315 14.5003 4.5 14.5003H11.5C13.1569 14.5003 14.5 13.1571 14.5 11.5003V6.97746C14.5 6.04606 14.0674 5.16748 13.3291 4.59959L9.82913 1.90728C8.75078 1.07778 7.24922 1.07778 6.17087 1.90728L2.67087 4.59959Z'
        />
      </mask>
      <path
        d='M2.67087 4.59959L1.7563 3.41066L1.7563 3.41066L2.67087 4.59959ZM13.3291 4.59959L14.2437 3.41066L14.2437 3.41066L13.3291 4.59959ZM9.82913 1.90728L8.91457 3.09622L8.91457 3.09622L9.82913 1.90728ZM6.17087 1.90728L7.08543 3.09622L6.17087 1.90728ZM1.7563 3.41066C0.648918 4.26249 0 5.58035 0 6.97746H3C3 6.51176 3.21631 6.07247 3.58543 5.78853L1.7563 3.41066ZM0 6.97746V11.5003H3V6.97746H0ZM0 11.5003C0 13.9855 2.01472 16.0003 4.5 16.0003V13.0003C3.67157 13.0003 3 12.3287 3 11.5003H0ZM4.5 16.0003H11.5V13.0003H4.5V16.0003ZM11.5 16.0003C13.9853 16.0003 16 13.9855 16 11.5003H13C13 12.3287 12.3284 13.0003 11.5 13.0003V16.0003ZM16 11.5003V6.97746H13V11.5003H16ZM16 6.97746C16 5.58035 15.3511 4.26249 14.2437 3.41066L12.4146 5.78853C12.7837 6.07247 13 6.51176 13 6.97746H16ZM14.2437 3.41066L10.7437 0.718348L8.91457 3.09622L12.4146 5.78853L14.2437 3.41066ZM10.7437 0.718348C9.12617 -0.525909 6.87383 -0.525907 5.2563 0.718349L7.08543 3.09622C7.62461 2.68147 8.37539 2.68147 8.91457 3.09622L10.7437 0.718348ZM5.2563 0.718349L1.7563 3.41066L3.58543 5.78853L7.08543 3.09622L5.2563 0.718349Z'
        fill='white'
        mask='url(#path-1-inside-1_2310_38841)'
      />
    </svg>
  );
};

export default MainSvg;
